// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProposalDiscussion } from './proposal-discussion';
import { ProposalVote } from './proposal-vote';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Proposal extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get voteCount() {
        let count = 0;
        if (this.proposalVotes && this.proposalVotes.length > 0) {
            this.proposalVotes.forEach((vote) => {
                if (vote.yesVote || vote.noVote) count++;
            });
        }
        return count;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  allowDiscussion!: boolean;
  approved?: Date;
  congregationalVote!: boolean;
  created?: Date;
  createdBy?: string;
  declined?: Date;
  deleted?: Date;
  description?: string;
  emailed?: Date;
  fromCommittee?: string;
  notes?: string;
  showPreview!: boolean;
  title?: string;
  toCommittee?: string;
  proposalDiscussions!: ProposalDiscussion[];
  proposalVotes!: ProposalVote[];
}

